import { NavLink, useRouteMatch } from 'react-router-dom'
import cx from 'classnames'

import { IconType } from 'common/icons/Icon'

type Props = {
  title: string
  to: string
  Icon?: IconType
  isDisabled?: boolean
  className?: string
  activePaths?: string[]
}

const SubNavItem = ({
  title,
  Icon,
  to,
  isDisabled,
  className,
  activePaths,
}: Props) => {
  const match = useRouteMatch({
    path: [to, ...(activePaths ?? [])],
    exact: true,
  })
  const isActive = !!match

  return (
    <NavLink
      data-cy={`subnav-link-${title}`}
      data-testid="subnav-link"
      exact
      to={to}
      onClick={(event) => {
        if (isDisabled) {
          event.preventDefault()
        }
      }}
      className={cx(
        'group hover:text-yellow-200 transition-colors duration-300',
        {
          'cursor-not-allowed': isDisabled,
          'text-yellow-200': isActive,
          'text-white': !isActive,
        },
        className
      )}
    >
      {Icon && <Icon className={cx('mr-4')} isDefaultColor={false} />}
      {title}
    </NavLink>
  )
}

export default SubNavItem
